import { create } from "zustand";
import { combine } from "zustand/middleware";
import { SolarConfigurationData } from "@components/forms/solar-configuration/types.ts";

const DEFAULT_SOLAR_CONFIGURATION: SolarConfigurationData = {};

export const useSolarConfigurationStore = create(
  combine(DEFAULT_SOLAR_CONFIGURATION, (set) => ({
    setHasSolar: (hasSolar: SolarConfigurationData["hasSolar"]) =>
      set((state) => ({ ...state, hasSolar })),
    setSolarArraySize: (
      solarArraySize: SolarConfigurationData["solarArraySize"],
    ) => set((state) => ({ ...state, solarArraySize })),
  })),
);
